import classNames from 'classnames'
import { CSSProperties, useMemo } from 'react'
import { RenderElementProps } from 'slate-react'

import {
  SeparatorAlignment,
  SeparatorWidth,
} from 'core-components/library/richTextEditor/interface/TSeparator'

interface IProps {
  style: CSSProperties
}

export const Separator = (props: RenderElementProps & IProps) => {
  const className = useMemo(() => {
    if (props.element['width'] || props.element['height'] || props.element['alignment']) {
      const widthValue = SeparatorWidth.find((item) => item.name === props.element['width'])
      const alignmentValue = SeparatorAlignment.find(
        (item) => item.name === props.element['alignment']
      )
      return classNames(props.element['className'], widthValue?.value, alignmentValue?.value)
    }
    // A plain separator (no width/height/alignment/background) has no inline height or background to
    // paint, and RichTextEditor__separator removes the native <hr> border — which would render it
    // invisible in the editor. Drop the class in that case so the browser's default rule shows,
    // matching the bare `<hr/>` produced in Source/Preview.
    return props.element['backgroundColor'] ? props.element['className'] : undefined
  }, [
    props.element,
    props.element['className'],
    props.element['width'],
    props.element['height'],
    props.element['alignment'],
    props.element['backgroundColor'],
  ])

  return (
    <div>
      <hr
        className={className}
        style={{
          ...props.style,
          height: props.element['height'],
          backgroundColor: props.element['backgroundColor'],
        }}
        {...props.attributes}
        contentEditable={false}
      />
      {props.children}
    </div>
  )
}
